export default {
  name: 'Dashboard',
  data: function data() {
    return {
      me: this.appVars.me,
      loading: false,
      has_fluentcrm: false,
      has_thrivecart: false,
      require_setup: false,
      installing: false,
      stats: false
    };
  },
  computed: {
    greetingTime: function greetingTime() {
      var m = this.moment();
      var g = null; //return g

      if (!m || !m.isValid()) {
        return;
      } //if we can't find a valid or filled moment, we return.

      var split_afternoon = 12; //24hr time to split the afternoon
      var split_evening = 17; //24hr time to split the evening
      var currentHour = parseFloat(m.format("HH"));
      if (currentHour >= split_afternoon && currentHour <= split_evening) {
        g = "afternoon";
      } else if (currentHour >= split_evening) {
        g = "evening";
      } else {
        g = "morning";
      }
      return g;
    }
  },
  methods: {
    getDashboardInfo: function getDashboardInfo() {
      var _this = this;
      this.loading = true;
      this.$get('reports/dashboard').then(function (response) {
        _this.has_thrivecart = response.has_thrivecart;
        _this.has_fluentcrm = response.has_fluentcrm;
        _this.require_setup = response.require_setup;
        _this.stats = response.stats;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
      });
    },
    installFluentCRM: function installFluentCRM() {
      var _this2 = this;
      this.installing = true;
      this.$post('reports/install-fluentcrm').then(function (response) {
        _this2.$notify.success(response.message);
        _this2.getDashboardInfo();
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {
        _this2.installing = false;
      });
    }
  },
  mounted: function mounted() {
    this.getDashboardInfo();
  }
};